import React from 'react'
import { useForm } from 'react-hook-form';
import type { SubmitHandler } from 'react-hook-form';

import { useOrderUpdate } from '../../api/order/update-order';
import { ButtonFilled } from '../common/button/button-filled';
import { Checkbox } from '../form/checkbox';
import { LabelInput } from '../form/labelInput';


type FormValues = {
    trackingNumber: string;
    isLabelSent: boolean;
}

type Props = {
    orderId: number;
}

const OrderShippingPickupForm: React.FC<Props> = ({ orderId }) => {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<FormValues>();
  const updateOrder = useOrderUpdate();

  const onSubmit: SubmitHandler<FormValues> = (data) => {
    updateOrder.mutate({
        id: orderId,
        trackingNumber: data.trackingNumber,
        status: "LABEL_SENT"
    });
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
        <div className="text-left flex flex-col space-y-3">
            <div>
                <LabelInput title={"Tracking Number"} attributes={{
                    ...register('trackingNumber', {
                        disabled: isSubmitting,
                        required: "Tracking Number is required",
                        minLength: {
                            value: 5,
                            message: "Tracking Number must be at least 5 characters long"
                        },
                    })
                }}/>
                {errors.trackingNumber && <span className="text-red-500 text-sm">{errors.trackingNumber.message}</span>}
            </div>
            <div className="flex flex-col items-start">
                <Checkbox title={"Label Sent"} attributes={{
                    ...register('isLabelSent', {
                        disabled: isSubmitting,
                        required: "Label must be sent",
                    })
                }}/>
                {errors.trackingNumber && <span className="text-red-500 text-sm">{errors.isLabelSent?.message}</span>}
            </div>
        </div>
        <ButtonFilled text="Submit" isLoading={isSubmitting} />
    </form>
  )
}

export default OrderShippingPickupForm
